export function setMemberOffers(state, payload) {
  state.memberOffers = payload;
}

export function setLoading(state, payload) {
  state.isLoading = payload;
}
